import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ _jsx("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M8.15258 12.5325L2.75708 6.36525C2.12033 5.63963 2.63783 4.5 3.60421 4.5H14.3952C14.6115 4.49981 14.8232 4.56197 15.0051 4.67903C15.1869 4.79609 15.3312 4.96309 15.4206 5.16003C15.51 5.35697 15.5407 5.5755 15.5091 5.78945C15.4775 6.0034 15.3849 6.20371 15.2423 6.36638L9.84683 12.5314C9.74124 12.6522 9.61102 12.7491 9.46491 12.8154C9.3188 12.8818 9.16018 12.9161 8.99971 12.9161C8.83923 12.9161 8.68062 12.8818 8.53451 12.8154C8.3884 12.7491 8.25818 12.6522 8.15258 12.5314V12.5325Z",
                fill: "#7D9CD1"
            })
        })
    }));
};
export default Icon;
